import GatewayFirmware from './container/GatewayFirmware'

// Sync route definition
export default {
  path: '/developer/gatewayfirmware',
  component: GatewayFirmware,
}
